import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  changeDefaultQueryParams,
  changeQueryParams,
  changeStaticQueryParams,
  selectItemById,
  selectItemsIds,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import { connect } from 'react-redux';

export default function createContainer(ChildContainer) {
  class SpecialPagesListContainer extends Component {
    constructor(props) {
      super(props);
      this.handleSendRequest();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.match.params.tag !== this.props.match.params.tag) {
        this.handleSendRequest();
      }
    }

    handleSendRequest() {
      this.props.changeStaticQueryParams({ tag: this.props.match.params.tag });
      this.props.sendRequest();
    }

    render() {
      return <ChildContainer {...this.props} />;
    }
  }
  SpecialPagesListContainer.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        tag: PropTypes.string
      }).isRequired
    }).isRequired,
    // CONNECT DISPATCH
    sendRequest: PropTypes.func.isRequired,
    changeStaticQueryParams: PropTypes.func.isRequired
  };

  const mapStateToProps = (state, props) => ({
    requestState: selectRequestState(state, props.listReduceName),
    itemsIds: selectItemsIds(state, props.listReduceName),
    selectItemById: id => selectItemById(state, props.listReduceName, id)
  });

  const mapDispatchToProps = (dispatch, props) => ({
    changeStaticQueryParams: queryParams =>
      dispatch(changeStaticQueryParams(props.listReduceName, queryParams)),
    changeDefaultQueryParams: queryParams =>
      dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
    changeQueryParams: queryParams =>
      dispatch(changeQueryParams(props.listReduceName, queryParams)),
    sendRequest: () => dispatch(sendRequest(props.listReduceName))
  });
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(SpecialPagesListContainer);
}



// WEBPACK FOOTER //
// ./src/components/SpecialPages/containers/SpecialPagesListContainer/SpecialPagesListContainer.js